import React from 'react';

export default function CompleteMessage({ message }: { message: string | undefined }) {
  if (!message) {
    return null;
  }

  return (
    <div>
      {message}
    </div>
  );
}